import React from "react";
import { Badge } from "../components/ui/badge";
import { Plug, ArrowLeftRight, Server, ShieldCheck } from "lucide-react";

const CONNECTORS = [
  { name: "PACT Network (V3)", desc: "Exchange product carbon footprints machine-to-machine with conformant partners.", status: "Modelled — wiring in Release 3", icon: ArrowLeftRight },
  { name: "ERP / Procurement feed", desc: "Pull purchase transactions and spend so suppliers needn't re-key data that already exists.", status: "Modelled — wiring in Release 3", icon: Server },
  { name: "Supplier Portal reuse", desc: "Suppliers submit once and, with permission, reuse answers across customers and cycles.", status: "Live — reuse across cycles", icon: ShieldCheck },
];

export default function DataExchange() {
  return (
    <div className="p-6 space-y-5" data-testid="data-exchange-page">
      <div>
        <div className="label-eyebrow mb-1">Supply Chain</div>
        <h2 className="font-display text-2xl font-bold tracking-tight flex items-center gap-2"><Plug className="h-6 w-6 text-accent" /> Data Exchange & Integrations</h2>
        <p className="text-muted-foreground text-sm mt-1 max-w-2xl">Machine-to-machine exchange so supplier data flows in without re-keying. PCFs are stored PACT-compatible today; live connections are wired in Release 3.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {CONNECTORS.map((c) => (
          <div key={c.name} className="card-flat p-5" data-testid={`connector-${c.name.split(" ")[0].toLowerCase()}`}>
            <c.icon className="h-5 w-5 text-accent mb-2" />
            <div className="font-display font-bold">{c.name}</div>
            <p className="text-xs text-muted-foreground mt-1">{c.desc}</p>
            <Badge variant="outline" className="text-[9px] uppercase mt-3">{c.status}</Badge>
          </div>
        ))}
      </div>
      <div className="card-flat p-4 text-[11px] text-muted-foreground">Carbon Data Objects are modelled PACT V3-compatible now (original PCF, declared unit, boundary, period, geography, method, quality, evidence). Formal conformance and live endpoints activate in Release 3.</div>
    </div>
  );
}
